import React, { useCallback, useEffect } from 'react';
import { Address } from '../../../types/models/mvcapi';

const tr = require('ts-translate-js').default.boundTR;

type EditaddressPanelProps = {
    address: Address;
    addressType: string;
    addressErrors: any[];
    audtoEditMode?: boolean;
    onCancel: () => void;
    onConfirm: (address: any) => void;
};

export function EditAddress({address, addressType, addressErrors, audtoEditMode, onCancel, onConfirm} : EditaddressPanelProps) {
    const [editedAddress, setEditedAddress] = React.useState(address);

    useEffect(() => {
        if(addressErrors) {
            addressErrors.forEach((error) => {
                document.getElementsByName(error.name)[0].classList.add('field-error');
            });
    
            return () => {
                addressErrors.forEach((error) => {
                    document.getElementsByName(error.name)[0].classList.remove('field-error');
                });
            };
        }
    }, [addressErrors]);

    const handleOnBlur = useCallback(() => {
        onConfirm(editedAddress);
    }, [editedAddress, onConfirm]);

    const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.currentTarget;

        document.getElementsByName(name)[0].classList.remove('err');

        setEditedAddress({...editedAddress, [name]: value });
    }, [setEditedAddress, editedAddress]);

    return (
        <div className="address form-horizontal">
            <form onSubmit={() => onConfirm(editedAddress)}>
                <h4>{addressType}</h4>
                <div className='well'>
                    <div className="form-group">
                        <label htmlFor="inputAddress1" className="col-sm-3 control-label left">{tr("profileinfo.address")}</label>
                        <div className='col-sm-3'>
                            <input type="text" id="inputAddress1" name="Address1" className="form-control" value={editedAddress.Address1} onBlur={handleOnBlur} onChange={(e) => handleInputChange(e)}></input>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="col-sm-3 control-label left" htmlFor="inputAddress2">{tr("profileinfo.address2")}
                            <p className="help-block">{tr("profileedition.optional")}</p>
                        </label>
                        <div className='col-sm-3'>
                            <input type="text" id="inputAddress2" name="Address2" className="form-control" value={editedAddress.Address2} onBlur={handleOnBlur} onChange={(e) => handleInputChange(e)}></input>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="inputCity" className="col-sm-3 control-label left">{tr("profileinfo.city")}</label>
                        <div className='col-sm-3'>
                            <input type="text" id="inputCity" name="City" className="form-control" value={editedAddress.City} onBlur={handleOnBlur} onChange={(e) => handleInputChange(e)}></input>
                        </div>  
                    </div>

                    <div className="form-group">
                        <label htmlFor="inputProvince" className="col-sm-3 control-label left">{tr("profileinfo.province")}</label>
                        <div className='col-sm-3'>
                            <input type="text" id="inputProvince" name="Province" className="form-control" value={editedAddress.Province} onBlur={handleOnBlur} onChange={(e) => handleInputChange(e)}></input>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="inputPostalCode" className="col-sm-3 control-label left">{tr("profileinfo.postalcode")}</label>
                        <div className='col-sm-3'>
                            <input type="text" id="inputPostalCode" name="PostalCode" className="form-control" value={editedAddress.PostalCode} onBlur={handleOnBlur} onChange={(e) => handleInputChange(e)}></input>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="inputCountry" className="col-sm-3 control-label left">{tr("profileinfo.country")}</label>
                        <div className='col-sm-3'>
                            <input type="text" id="inputCountry" name="Country" className="form-control" value={editedAddress.Country} onBlur={handleOnBlur} onChange={(e) => handleInputChange(e)}></input>
                        </div>
                    </div>
                    {!audtoEditMode &&
                    <div className="form-group">
                        <div className="btn-toolbar">
                            <button className="btn btn-default" type="button" onClick={() => onCancel()}>{tr("Annuler")}</button>
                            <button className="btn btn-primary" type="submit">{tr("Confirmer")}</button>
                        </div>
                    </div>}
                </div>
            </form>
        </div>
    );
}
